import { render, staticRenderFns } from "./PromotionReport.vue?vue&type=template&id=8c7bd590&scoped=true"
import script from "./PromotionReport.vue?vue&type=script&lang=js"
export * from "./PromotionReport.vue?vue&type=script&lang=js"
import style0 from "./PromotionReport.vue?vue&type=style&index=0&id=8c7bd590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7bd590",
  null
  
)

export default component.exports